module.exports = __webpack_public_path__ + "img/cloudTelephony.fbeb1a35.png";